import { trapFocus } from './trap-focus';
import { toggleScrollLock } from '../utils';

window.addEventListener('DOMContentLoaded', () => {
  const topMenuWrapper = document.querySelector('.top-menu-wrapper');
  const primaryNav = document.querySelector('.primary-navigation');
  const userMenu = document.querySelector('.user-menu');
  const myPageToggler = document.querySelector('.my-page-toggler');
  const pageContent = document.querySelectorAll('header, main, footer');
  const menuButtons = document.querySelectorAll('[data-toggle="menu"]');
  const menuTogglers = document.querySelectorAll('.menu-item-toggler');

  function toggleUserMenu(e) {
    if (e?.preventDefault) e.preventDefault();
    myPageToggler?.classList.toggle('open');
    topMenuWrapper?.classList.toggle('open');
    topMenuWrapper?.classList.toggle('user-menu');
    userMenu?.classList.toggle('open');
  }

  function toggleMenu() {
    if (userMenu?.classList.contains('open')) {
      toggleUserMenu();
    }

    topMenuWrapper?.classList.toggle('open');
    primaryNav?.classList.toggle('open');
    menuButtons.forEach(btn => btn.classList.toggle('open'));
    toggleScrollLock();

    const expanded = topMenuWrapper?.classList.contains('open');
    pageContent.forEach(el =>
      expanded
        ? el.setAttribute('aria-hidden', 'true')
        : el.removeAttribute('aria-hidden')
    );

    if (expanded) {
      document.getElementById('menu')?.focus();
      console.log('primaryNav', primaryNav);
      trapFocus(primaryNav);
    } else {
      const visibleBtn = Array.from(menuButtons).find(btn =>
        btn.classList.contains('open')
      );
      (visibleBtn || menuButtons[0])?.focus();
    }
  }

  topMenuWrapper?.addEventListener('click', e => {
    if (e.target !== e.currentTarget) return;
    if (userMenu?.classList.contains('open')) {
      toggleUserMenu();
    }
  });

  menuButtons.forEach(btn => btn.addEventListener('click', toggleMenu));

  window.addEventListener('keydown', e => {
    if (e.key === 'Escape') {
      if (primaryNav?.classList.contains('open')) {
        toggleMenu();
      }
      if (userMenu?.classList.contains('open')) {
        toggleUserMenu();
      }
    }
  });

  menuTogglers.forEach(btn => {
    btn.addEventListener('click', e => {
      const parent = e.currentTarget.parentElement;
      parent?.classList.toggle('expanded');

      const closestUserMenu = e.currentTarget.closest('.user-menu');
      closestUserMenu?.classList.toggle('expanded');
    });
  });

  myPageToggler?.addEventListener('click', toggleUserMenu);
});
